import React from 'react';

import classes from './About.css';

import Badge from '../../../components/Badge/Badge';
import ParallaxImage from '../../../components/ParallaxImage/ParallaxImage';
import Section from '../../../hoc/Section/Section';
import ExtendImage from '../../../components/ExtendImage/ExtemdImage';

import Customer from '../../../assets/images/customer.svg';
import Agile from '../../../assets/images/agile_small.svg';
import Certified from '../../../assets/images/certified.svg';
import Img11 from '../../../assets/images/img11.jpg';
import Img13 from '../../../assets/images/img13.jpg';
import Img14 from '../../../assets/images/img14.jpg';
import Img15 from '../../../assets/images/img15.jpg';

const about = (props) => {

    return (
        <div className={classes.About} style={{color: props.color}}>
            <Section link="/#whoweare" mainSection="/"/>
            <h1 id="whoweare">Who We Are</h1>
            <div style={{width:"30%", margin: "auto", height:"1px", background: props.color, marginBottom: "100px"}}></div>
            <h2 style={{width:"100%"}}>RiseUp! A young and innovative start-up at the cutting edge of technology</h2>
            <p style={{width:"100%"}}>Our expertise is focused on agile management and development of innovative cross-platform and fully responsive mobile and web applications</p>
            
            <div className={classes.Badge}>

                <Badge image={Customer} color={props.color}>Customer Oriented</Badge>
                <Badge image={Agile} color={props.color}>Agile Expert</Badge>
                <Badge image={Certified} color={props.color}>Certified Partner</Badge>

            </div>

            <div style={{width: "100%", height:"400px", overflow:"hidden", margin: "50px 0"}}>
                <ParallaxImage><img className={classes.ImageMobileOnly} style={{width: "100%"}} src={Img11} alt=''/></ParallaxImage>
            </div>


            <h1 id="whatwedo">What We Do</h1>
            <div style={{width:"30%", margin: "auto", height:"1px", background: props.color}}></div>

            <Section link="/#whatwedo" mainSection="/"/>

            <div className={classes.Text} style={{color:props.color}}>

                <div className={classes.Flex30}>
                    <div className={classes.Image}>
                        <ExtendImage><img src={Img13} alt=''/></ExtendImage>
                    </div>
                    <div className={classes.Title}>High Quality Solutions</div>
                    <div className={classes.Description}>
                        Rise Up provides high quality consulting, coaching and training solutions for clients seeking 
                        the benefits of agile software development including Lean-UX, DevOps and Continuous Delivery.
                    </div>
                </div>
                <div className={classes.Flex30}>
                    <div className={classes.Image}>
                        <ExtendImage delay="0.4s"><img src={Img14} alt=''/></ExtendImage>
                    </div>
                    <div className={classes.Title}>Performance Improvement</div>
                    <div className={classes.Description}>
                        Its our passion to improve the performance of software development teams and programs while 
                        maximizing the delivery of business value through innovative agile technology delivery techniques.
                    </div>

                </div>
                <div className={classes.Flex30}>
                    <div className={classes.Image}>
                        <ExtendImage delay="0.5s"><img src={Img15} alt=''/></ExtendImage>
                    </div>
                    <div className={classes.Title}>Business Value</div>
                    <div className={classes.Description}>
                        No matter what your stage of agile adoption is, just beginning, 
                        or needing to take your teams and programs to the next level, 
                        we have solutions that will deliver your organizations an improved flow of business value to your customers.
                    </div>

                </div>
            </div>
        </div>
    );
}

export default about;


// WEBPACK FOOTER //
// ./client/src/containers/Home/About/About.js